<ng-container *ngFor="let childRow of row.children">
  <app-body-row [row]="childRow" [data]="data" [child]="true" [parent]="row"></app-body-row>
  <app-recursive-row *ngIf="childRow.children" [row]="childRow" [data]="data"></app-recursive-row>
</ng-container>
